<div class="content-bg">
    <div class="main">
        <app-landing-toolbar></app-landing-toolbar>
        <app-landing-content></app-landing-content>
    </div>
    <app-landing-footer></app-landing-footer>
</div>